import { create } from 'zustand';
import { IExercise } from '../../../core/models/exercise';

interface ExercisePrintState {
  exercises: IExercise[] | [];
  isLoading: boolean;
  difficulty: string[];
  unanswered: boolean;
  questionOptions: string[];
  favorites: boolean;
  setExercises: (exercise: IExercise[]) => void;
  setIsLoading: (loading: boolean) => void;
  setDifficulty: (difficulties: string[]) => void;
  setUnanswered: (option: boolean) => void;
  setQuestionOptions: (types: string[]) => void;
  setFavorites: (favorite: boolean) => void;
  resetExercisePrint: () => void;
}

export const useExercisePrintStore = create<ExercisePrintState>((set) => ({
  exercises: [],
  isLoading: false,
  difficulty: [],
  unanswered: false,
  questionOptions: [],
  favorites: false,
  setExercises: (exercise: IExercise[]) => set({ exercises: exercise }),
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  setDifficulty: (difficulties: string[]) => set({ difficulty: difficulties }),
  setUnanswered: (option: boolean) => set({ unanswered: option }),
  setQuestionOptions: (types: string[]) => set({ questionOptions: types }),
  setFavorites: (favorite: boolean) => set({ favorites: favorite }),
  resetExercisePrint: () => set({
    exercises: [],
    isLoading: false,
    difficulty: [],
    unanswered: false,
    questionOptions: [],
    favorites: false,
  })
}));
